import { useNavigate } from "react-router-dom";

export default function BecomeCreator() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#f9fafb] font-sans">

      {/* 🔥 HERO */}
      
      
      <div className="relative pt-32 pb-24 px-4 text-center overflow-hidden">
  <div className="absolute top-6 left-4 md:left-10 z-20">
    <button
      onClick={() => navigate(-1)}
      className="flex items-center gap-2 px-4 py-2 
                 bg-white/80 backdrop-blur-md 
                 border border-gray-200 
                 rounded-full text-sm font-medium text-[#1f2d1f]
                 hover:bg-white transition shadow-sm"
    >
      ← Back
    </button>
  </div>
  {/* soft gradient + glow */}
  <div className="absolute inset-0 bg-gradient-to-b from-[#5b6f00]/10 via-white to-transparent"></div>

  <div className="max-w-4xl mx-auto relative z-10">

    <h1 className="text-4xl md:text-6xl font-extrabold text-[#1f2d1f] mb-6 leading-tight">
      Turn Your Travel Into
      <span className="block text-[#5b6f00]">Digital Experiences</span>
    </h1>

    <p className="text-gray-600 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
      Not just content anymore — create real travel products people can use,
      follow, and soon pay for.
    </p>

    {/* small trust line */}
    <p className="text-xs text-gray-400 mt-4">
      Join early creators shaping the future of travel planning
    </p>

  </div>
</div>
      {/* 💡 BIG IDEA */}
      <div className="max-w-5xl mx-auto px-4 mb-24">
  <div className="bg-white p-10 rounded-3xl border border-gray-100 shadow-[0_10px_40px_rgb(0,0,0,0.04)] text-center">

    <h2 className="text-3xl font-bold text-[#1f2d1f] mb-6">
      From Content → Product → Income
    </h2>

    <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm font-medium">
      <span className="bg-[#f7f6f1] px-5 py-2 rounded-full">Travel Content</span>
      <span className="text-gray-400">→</span>
      <span className="bg-[#f7f6f1] px-5 py-2 rounded-full">Interactive Trip</span>
      <span className="text-gray-400">→</span>
      <span className="bg-[#5b6f00]/10 px-5 py-2 rounded-full text-[#5b6f00]">
        Earn (Coming Soon)
      </span>
    </div>

    <p className="text-gray-500 text-sm mt-6 max-w-xl mx-auto">
      Your travel knowledge becomes something people can actually use — not just scroll past.
    </p>
  </div>
</div>

      {/* ⚙️ HOW IT WORKS */}
      <div className="max-w-6xl mx-auto px-4 mb-20">
        <h2 className="text-3xl font-bold text-[#1f2d1f] mb-8 text-center">
          How It Works
        </h2>

        <div className="grid md:grid-cols-5 gap-6">
          {[
            {
              title: "Apply",
              desc: "Profile → Become Creator → Fill form",
            },
            {
              title: "Get Approved",
              desc: "Takes 4–24 hours",
            },
            {
              title: "Dashboard",
              desc: "Unlock creator dashboard",
            },
            {
              title: "Create Trip",
              desc: "Add itinerary, tips, details",
            },
            {
              title: "Publish",
              desc: "Turn it into a digital product",
            },
          ].map((step, i) => (
            <div
              key={i}
              className="bg-white p-5 rounded-xl border border-gray-100 shadow-sm"
            >
              <p className="text-[#5b6f00] font-bold mb-2">
                Step {i + 1}
              </p>
              <h3 className="font-semibold text-[#1f2d1f] mb-1">
                {step.title}
              </h3>
              <p className="text-gray-500 text-sm">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* 🚧 BETA */}
      <div className="max-w-5xl mx-auto px-4 mb-24">
  <div className="bg-yellow-50 border border-yellow-200 rounded-3xl p-8 text-center">

    <h3 className="text-lg font-bold text-yellow-800 mb-2">
      🚧 Early Access Phase
    </h3>

    <p className="text-yellow-700 text-sm max-w-2xl mx-auto">
      Monetization is coming soon. Early creators will have their trips ready
      and be first in line to earn when we launch.
    </p>

  </div>
</div>

      {/* ❓ FAQ */}
      <div className="max-w-5xl mx-auto px-4 mb-20">
        <h2 className="text-3xl font-bold text-[#1f2d1f] mb-8 text-center">
          FAQ
        </h2>

        <div className="space-y-4">
          {[
            {
              q: "Who can apply?",
              a: "Influencers & creators with travel content",
            },
            {
              q: "Is it free?",
              a: "Yes, joining is completely free",
            },
            {
              q: "When will monetization start?",
              a: "Soon after beta phase",
            },
          ].map((item, i) => (
            <div
              key={i}
              className="bg-white p-5 rounded-xl border border-gray-100"
            >
              <p className="font-semibold text-[#1f2d1f] mb-1">
                {item.q}
              </p>
              <p className="text-gray-500 text-sm">{item.a}</p>
            </div>
          ))}
        </div>
      </div>

      {/* 🔥 CTA */}
      <div className="text-center pb-24">

  <h2 className="text-3xl font-bold text-[#1f2d1f] mb-4">
    Ready to turn your travel into income?
  </h2>

  <p className="text-gray-500 mb-6">
    Start building your first digital trip today.
  </p>

  <button
    onClick={() => navigate("/profile")}
    className="px-10 py-4 bg-[#5b6f00] text-white rounded-full font-semibold 
               hover:opacity-90 transition shadow-lg text-lg"
  >
    Apply to Become a Creator →
  </button>

</div>
    </div>
  );
}